import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import './Invoice.module.css';
import Loading from '../../components/loading/Loading.js';
import { GetInvoiceAPI } from '../../api/API.js';
import CustomButton from '../../components/buttons/CustomButton.js';
import IconPrint from '@mui/icons-material/Print';
import { CreatePDF } from '../../utils/Utils.js';
import { DataProviderInstance } from "../../api/DataProvider";
import DemoTag from '../../components/demo-data/DemoTag';
import { isDemoRecord } from '../../components/demo-data/demoData';

function Invoice() {

  const { id } = useParams();
  const [data, setData] = useState(null);
  const pdfContentRef = useRef(null);

  const { CompanyConfig, SetAppointmentInvoice, GetPatientById } = DataProviderInstance();

  useEffect(() => {
    LoadData();
  }, [id]);

  function LoadData() {
    GetInvoiceAPI(id, (result) => {
      setData(result);
    });
  };

  function OnPrintHandler() {
    const fileName = `${data.patient.name.replace(/\s/g, '_')}_${data.invoice.createdAt}_n${id}.pdf`;
    const content = pdfContentRef.current;

    CreatePDF(content, fileName);
  }

  if (data == null) {
    return <Loading />;
  } else if (!data.invoice) {
    // Sem pagamento o endpoint responde 200 com invoice nulo
    return (
      <div className='page-content'>
        <p>Pagamento não encontrado.</p>
      </div>
    );
  } else {

    let paymentMethod = CompanyConfig.PaymentOptions.find(option => option.Id == data.invoice.paymentMethod).Label;
    let date = new Date(data.invoice.createdAt).toLocaleString();

    return (
      <div className='page-content' >
        {isDemoRecord(data.invoice) && <p><DemoTag label="Pagamento de exemplo" /></p>}
        <div ref={pdfContentRef}>
          <p>Nome: {data.patient.name}</p>
          <p>Data: {date}</p>
          <p>Valor: {Number(data.invoice.price || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
          <p>Método: {paymentMethod}</p>
        </div>

        <CustomButton
          variant="outlined"
          style="primary"
          label={"Imprimir"}
          icon={<IconPrint />}
          onClick={OnPrintHandler}
        />
      </div>
    );
  }
}

export default Invoice;